import { render } from "./LambdaForm.vue?vue&type=template&id=12a4ea20&ts=true"
import script from "./LambdaForm.vue?vue&type=script&lang=ts"
export * from "./LambdaForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__